import React from 'react';
import {
  Heading,
  Stack,
  Container,
  Row,
  Column,
} from '@grubhubprod/gh-cookbook-react';
import { FormProvider, useForm } from 'react-hook-form/dist/index.ie11';
import PageHeader from 'src/components/enterprise/layout/PageHeader';
import { useAuth } from 'src/components/AuthProvider/AuthProvider';
import PageSection from 'src/components/enterprise/layout/PageSection';
import { ParentAccountsRow } from 'src/components/enterprise/Parents/Accounts/ParentAccountsController/ParentAccountsRow/ParentAccountsRow';
import { TieredAccountsTable } from 'src/components/enterprise/Parents/Admin/TieredAccountTable/TieredAccountsTable';
import { useSearchParentAccountsByParentAdmin } from 'src/components/enterprise/Parents/Admin/hooks/useSearchParentAccountsByParentAdmin/useSearchParentAccountsByParentAdmin';
import { ParentAdminTableFormProps } from 'src/components/enterprise/Parents/Admin/ParentAdminsController/types';
import { TableSearchForm } from 'src/components/enterprise/Parents/TableSearchForm/TableSearchForm';
import { ISearchParams } from 'src/utilities/useSearchHooks';
import { NumberOfParentAccounts } from 'src/components/enterprise/Parents/Accounts/ParentAccountsController/NumberOfParentAccounts/NumberOfParentAccounts';

export const ParentAccountsController: React.FC = () => {
  const { user } = useAuth();

  const dinerId = user.ud_id;

  const {
    searchResults: {
      resultsList,
      firstItemNumberFromPage,
      lastItemNumberFromPage,
      totalResults,
      doSearch,
    },
  } = useSearchParentAccountsByParentAdmin(dinerId);

  const formProps = useForm<ParentAdminTableFormProps>({
    defaultValues: {
      searchInput: '',
    },
  });

  const handleSearchWithParams = (query: string) => {
    const params: ISearchParams = {};
    if (query) {
      // If sending empty string to the query the result list is empty
      params.query = query;
    }

    doSearch(params);
  };

  const handleSearchClick = () => {
    const query = formProps.getValues('searchInput');
    handleSearchWithParams(query);
  };

  const noResultsMsg = 'No parent accounts';
  const headers = ['Name', 'Linked accounts'];

  return (
    <Container variant="default">
      <PageHeader>
        <Stack y="lg">
          <Heading variant="h2">Parent accounts</Heading>
        </Stack>
      </PageHeader>
      <Stack y="lg">
        <PageSection>
          <FormProvider {...formProps}>
            <Stack y="md">
              <Row>
                <Column phone={4}>
                  <TableSearchForm
                    onSearchClick={handleSearchClick}
                    placeholder="Search parent account"
                  />
                </Column>
              </Row>
            </Stack>
            <NumberOfParentAccounts
              firstItemNumberFromPage={firstItemNumberFromPage}
              lastItemNumberFromPage={lastItemNumberFromPage}
              totalResults={totalResults}
            />
            <TieredAccountsTable
              numberOfAccounts={resultsList.length}
              noResultsMsg={noResultsMsg}
              headers={headers}
            >
              {resultsList.map(({ name, parent_id, child_count }) => (
                <ParentAccountsRow
                  key={parent_id}
                  name={name}
                  childCount={child_count}
                  parentId={parent_id}
                />
              ))}
            </TieredAccountsTable>
          </FormProvider>
        </PageSection>
      </Stack>
    </Container>
  );
};
